export const useServiceWorker = async () => {
    if (!("serviceWorker" in navigator)) return;

    try {
        await navigator.serviceWorker.register("/service-worker.js");
    } catch (error) {
        console.error(`Registration failed with ${error}`);
    }
};
